import { Dispatch } from "redux";
import {
    getAccessoriesPaymentsFailure,
    getAccessoriesPaymentsRequest,
    getAccessoriesPaymentsSuccess,
} from "src/store/actions/accessoriesPayments";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import { getFromAuthed } from "src/store/dataService/routes/shared/osfetch";
import { findRoute } from "src/store/dataService/routes/util";
import { AccessoryPayments } from "Types/api/AccessoryPayments";

const getAccessoriesPayments = async (
    next: Dispatch,
    { payload: { uuid, vin } }: ActionType<typeof getAccessoriesPaymentsRequest>
) => {
    const response = await getFromAuthed(`/deals/${uuid}/accessories/vehicle/${vin}/payments`);

    if (response.ok) {
        const json = await response.json();
        const accessoryPayments: AccessoryPayments[] = [];
        Object.keys(json)
            .map(Number)
            .forEach((accessoryId) => {
                accessoryPayments.push({
                    id: accessoryId,
                    ...json[accessoryId],
                });
            });
        next(getAccessoriesPaymentsSuccess(vin, { payments: accessoryPayments }));
    } else {
        next(getAccessoriesPaymentsFailure(vin));
    }
};

const routes = {
    [getAccessoriesPaymentsRequest.type]: getAccessoriesPayments,
};

export default (next: Dispatch, action: any) => findRoute(routes)(next, action);
